@if (svc.isOpen() && !spinnerConversational() && ((sources()?.length ?? 0) > 0 || curatedLessonSources().length > 0)) {
  <div class="sources-backdrop" (click)="svc.close()"></div>

  <aside
    #sourcesPanel
    class="sources-panel fixed"
    role="dialog"
    aria-modal="true"
    id="sources-overview-panel"
  >
    <div class="resizer" (mousedown)="onStartResize($event)"></div>

    <div class="panel-content">
      <div class="sources-header">
        <div class="title-head flex flex-center flex-justify-between">
          <h5 class="body-large bold clamp">
            {{ answer() }}
          </h5>
          <button
            class="btn-link btn-close btn-small"
            data-fs-element="Open-Search-Button-Drawer-Close"
            (click)="svc.close()"
          >
            <mat-icon fontIcon="close" class="icon-m"></mat-icon>
          </button>
        </div>
      </div>

      <div class="sources-body">
        <div class="sources-list">
          <div class="flex flex-center flex-justify-between">
            <p class="body-medium bold">
              {{ 'KNOWLEDGE.PILLS_KNOWLEDGE.SOURCES_OVERVIEW' | translate }}
            </p>
            @if ((sources()?.length ?? 0) > 0) {
              <div>
                <button
                  data-fs-element="Open-Search-SourceFonts-CopyArray"
                  id="copy-sources-button"
                  mat-icon-button
                  appCopyData
                  [copiedType]="0"
                  [dataCopy]="[
                    'KNOWLEDGE.PILLS_KNOWLEDGE.SOURCES_OVERVIEW' | translate,
                    sourcesString(),
                  ]"
                  class="icon-button-s mdc-icon-button mat-mdc-icon-button mat-unthemed mat-mdc-button-base icon-hover"
                >
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            }
          </div>
          <ul class="list-source">
            @for (item of sources(); track item) {
              <li>
                <a
                  data-fs-element="Open-Search-SourceFonts-option"
                  class="source-label"
                  [title]="item.description"
                  [href]="item.url"
                  target="_blank"
                >
                  {{ item.description }}
                </a>
              </li>
            } @empty {
              <span class="body-small">
                {{ 'KNOWLEDGE.PILLS_KNOWLEDGE.SADPATH_SOURCES' | translate }}
              </span>
            }
          </ul>
          @if (curatedLessonSources().length > 0) {
            <p class="curated-sources-title">{{ 'OPEN_SEARCH.CURATED_LESSON_SOURCES' | translate }}</p>
            <ul class="list-source curated-source-list">
              @for (item of curatedLessonSources(); track item.reference) {
                <li>
                  <a
                    data-fs-element="Open-Search-Curated-Lesson-Source"
                    class="source-label"
                    [title]="item.fileName"
                    [href]="item.url"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ item.fileName }}
                  </a>
                </li>
              }
            </ul>
          }
        </div>
      </div>
    </div>
  </aside>
}
